import { calculateAbweichung } from '@/utils/helperFunctions';
import { ArbeitsbereichCellContent } from '../cells/ArbeitsbereichCell';
import { ArbeitszeitCellAntragContent } from '../cells/ArbeitszeitCell';
import { MitarbeiterContent } from '../cells/MitarbeiterCell';
import { RowTypeMap } from '../entities/Entities';
import { CellContent } from '../ToDoTableContent';
import { CellRenderers } from './renderer';
import { DauerCellContent } from '../cells/DauerCell';
import { HinweiseCellContent } from '../cells/HinweiseCell';
import { ActionCellContentAntrag } from '../cells/ActionCell';

const antragRenderer: CellRenderers<RowTypeMap['antrag']> = {
  name: (row) => (
    <CellContent className="">
      <MitarbeiterContent mitarbeiter={row.mitarbeiter} />
    </CellContent>
  ),
  arbeitsbereich: (row) => (
    <CellContent>
      <ArbeitsbereichCellContent arbeitsbereich={row.arbeitsbereich} />
    </CellContent>
  ),
  // oxlint-disable-next-line complexity
  arbeitszeit: (row) => (
    <CellContent>
      <ArbeitszeitCellAntragContent
        id={row.id}
        beginn={row?.beginn?.zeitstempel}
        kommen={row?.kommen?.zeitstempel}
        ende={row?.ende?.zeitstempel}
        gehen={row?.gehen?.zeitstempel}
        type={
          row.beginn && row.ende
            ? row.beginn.changeRequested && row.ende.changeRequested
              ? 'BeginnEnde'
              : row.ende.changeRequested
                ? 'Ende'
                : 'Beginn'
            : undefined
        }
        pausenDauer={row.getPausendauer()}
        pausen={row.pausen}></ArbeitszeitCellAntragContent>
    </CellContent>
  ),
  dauer: (row) => {
    let abweichung = undefined;
    if (row.beginn && row.ende) {
      abweichung = calculateAbweichung(
        row.beginn.zeitstempel.abweichung,
        row.ende.zeitstempel.abweichung,
      );
    }
    return (
      <CellContent>
        <DauerCellContent dauer={row.dauer} abweichung={abweichung} />
      </CellContent>
    );
  },
  hinweise: (row) => (
    <CellContent>
      <HinweiseCellContent
        rechtshinweise={row.rechtshinweise}
        zuschlaege={row.zuschlaege}
        termin={row.termin}
        bemerkung={row.bemerkung}
      />
    </CellContent>
  ),
  action: (row) => (
    <CellContent border={false}>
      <ActionCellContentAntrag id={row.id} />
    </CellContent>
  ),
};

export default antragRenderer;
